import { render } from "./SwdPhoneInput.vue?vue&type=template&id=527960d4&scoped=true"
import script from "./SwdPhoneInput.vue?vue&type=script&lang=js"
export * from "./SwdPhoneInput.vue?vue&type=script&lang=js"

import "./SwdPhoneInput.vue?vue&type=style&index=0&id=527960d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527960d4"]])

export default __exports__